import { motion } from "framer-motion";
import { Instagram, Volume2 } from "lucide-react";
import { SOCIALS } from "@/constants/content";

const ease = [0.16, 1, 0.3, 1];

// Akki's Instagram reels — embedded directly, tap inside to play with sound
const REELS = [
  { id: "DX8ccLQT1OG", title: "Reel 01" },
  { id: "DZZQD2tzs9m", title: "Reel 02" },
  { id: "DZRtmlbzYM0", title: "Reel 03" },
];

export const ReelsStrip = () => (
  <section id="reels" data-testid="reels-strip" className="bg-white py-20 md:py-24 border-b border-[#E5E7EB] overflow-hidden">
    <div className="max-w-[1320px] mx-auto px-6 md:px-10">
      <div className="flex flex-wrap items-end justify-between gap-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, ease }}
        >
          <p className="font-mono text-[14px] tracking-[0.3em] uppercase text-[#4F6D8A]">On Set</p>
          <h2 className="mt-4 font-serif text-4xl md:text-5xl text-[#111827]">Latest Reels</h2>
          <span className="mt-5 block w-14 h-[2px] bg-[#4F6D8A]" />
        </motion.div>
        <p className="hidden md:flex items-center gap-2 font-mono text-[12px] tracking-[0.22em] uppercase text-[#6B7280]">
          <Volume2 size={12} /> Tap reel to play with sound
        </p>
      </div>

      <div className="mt-12 flex gap-6 overflow-x-auto snap-x snap-mandatory pb-4 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden md:grid md:grid-cols-3 md:overflow-visible">
        {REELS.map((reel, i) => (
          <motion.div
            key={reel.id}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-30px" }}
            transition={{ duration: 0.6, delay: i * 0.08, ease }}
            data-testid={`reel-card-${i}`}
            className="group relative shrink-0 w-[240px] md:w-auto snap-start rounded-[22px] overflow-hidden border border-[#E5E7EB] bg-white shadow-[0_15px_45px_-18px_rgba(15,42,67,0.25)] hover:shadow-[0_30px_70px_-20px_rgba(15,42,67,0.4)] hover:-translate-y-1.5 transition-all duration-300"
          >
            <div className="aspect-[9/16] w-full">
              <iframe
                src={`https://www.instagram.com/reel/${reel.id}/embed`}
                title={`Instagram ${reel.title}`}
                loading="lazy"
                allow="autoplay; encrypted-media; picture-in-picture; clipboard-write"
                className="w-full h-full border-0"
              />
            </div>
            <span className="pointer-events-none absolute top-3 left-3 inline-flex items-center gap-1.5 font-mono text-[10px] font-bold tracking-[0.22em] uppercase text-white bg-[#0F2A43]/85 backdrop-blur px-3 py-1.5 rounded-full">
              <Instagram size={10} /> {reel.title}
            </span>
          </motion.div>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="mt-10 text-center"
      >
        <a
          data-testid="reels-instagram-link"
          href={SOCIALS.instagram}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 font-mono text-[13px] font-bold tracking-[0.22em] uppercase text-[#0F2A43] hover:text-[#4F6D8A] transition-colors"
        >
          <Instagram size={13} /> More on Instagram
        </a>
      </motion.div>
    </div>
  </section>
);
